import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  connectSocket,
  disconnectSocket,
  getSocket,
} from "../sockets/webSocketService";

const useSocketConnection = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const prevTokenRef = useRef(null);

  // Login, logout, or access-token refresh → reconnect with current credentials
  useEffect(() => {
    if (!token) {
      if (prevTokenRef.current) {
        disconnectSocket();
      }
      prevTokenRef.current = null;
      return;
    }

    if (token !== prevTokenRef.current) {
      connectSocket(dispatch);
      prevTokenRef.current = token;
    }
  }, [dispatch, token]);

  useEffect(() => {
    const ensureConnected = () => {
      if (!token) return;
      const socket = getSocket();
      if (!socket || socket.disconnected) {
        connectSocket(dispatch);
      }
    };

    window.addEventListener("focus", ensureConnected);
    document.addEventListener("visibilitychange", ensureConnected);

    return () => {
      window.removeEventListener("focus", ensureConnected);
      document.removeEventListener("visibilitychange", ensureConnected);
    };
  }, [dispatch, token]);
};

export default useSocketConnection;
